export const pageList = [
    "Login",
    "Registration",
    "ForgotPassword",
    "ResetPassword",
    "PageNotFound",
    "CreateNewPassword",
    "TwoFactorAuthentication",
    "Dashboard",
    "EducationalInstitution",
    "UserAccessControl",
    "ActionHistory",
    "Role",
    "ExpireAllPasswords",
    "EducationalDegree",
    "LearningFormat",
    "Faculty",
    "Profession",
    "AcademicDepartment",
    "Subject",
    "AcademicYear",
    "AcademicTerm",
    "StudyYears",
    "TeachingType",
    "SubjectCheckType",
    "BaselineData",
    "BaselineDataSetting",
    "ModularSubject",
    "PasswordPolicies",
    "ExpireAllPassword",
    "InstitutionalPreferences",
    "LearningPlan",
    "LearningPlanSettings",
    "Baseline",
    "Languages",
    "Translations",
    "Qualification",
    "Competences",
    "CompetencesSettings",
    "EducationalBlocks",
    "EducationalSettings",
    "EducationalSectors",
    "Permissions",
    "Employees",
    "RolesAssociations",
    "EmployeesOverview",
    "EmployeesSettings",
    "AcademicStructure",
    "Workload",
    "WorkLoadSettings",
    "LearningPlanRestore",
    "AcademicPositions",
    "AcademicScheduling",
    "EducationalDuration",
    "BaselineItems",
    "InstituteSettings",
    "SubjectGroups",
    "PositionsWorkingHours",
    "LearningPlanOpen",
    "Students",
    "UnitedLessons",
    "StudentsOverview",
    "UnitedItem",
    "StudentsSettings",
    "WorkloadItem",
    "AcademicStructureSettings",
    "StudyPaymentOptions",
    "ElectiveSubjects",
    "ElectiveItems",
    "AcademicWeekSetup",
    "NonWorkingDays",
    "RegistrationDocsRules",
];
